import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import instance from "../../axios/instance";
import { saveToken } from "../../utils/token";
import { Eye, EyeSlash, Health } from "iconsax-react";
import { ThemeContext } from "../../context/ThemeContext";
import Color from "color";
import getCustomSvg from "../../utils/theme/getCustomSvg";
import svgString from "../../svg/svg";

export const AdminOverrideAccess = () => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [logo, setLogo] = useState(null);
  const { themeColor } = useContext(ThemeContext);

  const isButtonNotActive = !userEmail || !password || !email;

  useEffect(() => {
    const clinicLogo = window.localStorage.getItem("CLINIC_LOGO");

    if (clinicLogo === "null" || !clinicLogo) {
      console.log("There is no logo use default");
      setLogo("/images/logo1.png");
    } else {
      console.log("there is logo");
      setLogo(clinicLogo);
    }
  }, []);

  const handleOverrideAccess = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      if (isButtonNotActive) {
        return;
      }
      const response = await instance.post("/admin/doctor/override-access", {
        adminEmail: email,
        email: userEmail,
        password,
      });
      saveToken(response.data.ACCESS_TOKEN);
      navigate("/dashboard/orders");
    } catch (error) {
      setLoading(false);
      setError("An error occurred");
    }
  };

  const customColor = {
    "#3a1b4415": Color(themeColor).alpha(0.2),
    "#3a1b44": themeColor,
  };

  const svgBackground = `data:image/svg+xml;base64,${btoa(
    getCustomSvg(svgString, customColor)
  )}`;

  return (
    <div className="grid grid-cols-5 min-h-[100svh]">
      <div
        style={{
          backgroundImage: `url('${svgBackground}')`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
        className="hidden lg:col-span-3 bg-[#3a1b443c] lg:flex flex-col justify-center relative overflow-clip"
      >
        <div className="px-10 py-4 flex absolute top-0 left-0">
          <img src={logo} className="w-36" />
        </div>

        <div className="rotate-12 text-primary-light absolute -bottom-12 right-6">
          <Health size={120} />
        </div>

        <div className="px-10 py-32 space-y-4">
          <div className="text-black font-bold text-[36px] max-w-[80%]">
            Empower <br />
            individuals on their <br />
            journey to optimal <br />
            health.
          </div>

          <div className="text-black font-regular max-w-[80%]">
            Experience the latest in pharmaceutical advancements with our
            cutting-edge formulations designed to address the unique needs of
            individuals seeking customized anti-aging solutions.
          </div>
        </div>

        <div className="font-medium text-[12px] flex gap-2 items-center absolute right-[10px] bottom-[10px]">
          Powered by
          <img src="/logo-bw.png" className="w-24" />
        </div>
      </div>

      <div className="py-20 col-span-5 lg:col-span-2 flex justify-center items-center">
        <div className="space-y-4">
          <div className="lg:hidden px-10 py-4 flex absolute top-0 left-0">
            <img src={logo} className="w-36" />
          </div>
          <div>
            <div className="font-semibold text-[20px]">Admin Access</div>
            <div className="font-regular text-gray-600 text-[15px]">
              Override user access
            </div>
          </div>

          <form onSubmit={handleOverrideAccess} className="space-y-4">
            <div>
              <div className="font-medium text-[14px] mb-1">
                Your admin email
              </div>
              <input
                onChange={(e) => setEmail(e.target.value)}
                className="w-full md:w-[350px] rounded-[4px] bg-[#f1f1f1] border font-regular text-[14px] border-[#D2D2D2] p-2 outline-none"
                placeholder="Enter your admin email"
                type="email"
                autoComplete="email"
                id="primary-email"
                value={email}
              />
            </div>

            <div>
              <div className="font-medium text-[14px] mb-1">
                Your admin password
              </div>
              <div className="w-[350px] rounded-[4px] bg-[#f1f1f1] flex items-center border border-[#D2D2D2] overflow-hidden">
                <input
                  type={isPasswordVisible ? "text" : "password"}
                  onChange={(e) => setPassword(e.target.value)}
                  className="flex-1 bg-[#f1f1f1] font-regular text-[14px] p-2 outline-none"
                  placeholder="•••••••••"
                />
                {isPasswordVisible ? (
                  <EyeSlash
                    color="grey"
                    onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                    className="mr-2 cursor-pointer"
                    size={16}
                  />
                ) : (
                  <Eye
                    color="grey"
                    onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                    className="mr-2 cursor-pointer"
                    size={16}
                  />
                )}
              </div>
            </div>
            <div>
              <div className="font-medium text-[14px] mb-1">User email</div>
              <input
                onChange={(e) => setUserEmail(e.target.value)}
                className="w-full md:w-[350px] rounded-[4px] bg-[#f1f1f1] border font-regular text-[14px] border-[#D2D2D2] p-2 outline-none"
                placeholder="Enter user email"
                autoComplete="secondary-email"
                id="secondary-email"
                type="email"
                value={userEmail}
              />
            </div>

            <div className="font-semibold text-sm text-red-500">{error}</div>

            <button
              type="submit"
              disabled={isButtonNotActive}
              className={`w-[350px] p-3 rounded-[4px] flex ${
                loading ? "bg-primary-light" : "bg-primary"
              } font-medium text-[14px] text-white justify-center items-center`}
            >
              Access account
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
